export const listEpcReferences = /* GraphQL */ `
  query ListSelfServingUsers(
    $filter: ModelSelfServingUsersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSelfServingUsers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        reference
      }
      nextToken
      __typename
    }
  }
`;

export const listEpcEmployersByCreatedAt = /* GraphQL */ `
  query EmployerByCreatedAt(
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEpcEmployerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employerByCreatedAt(
      byName: "Employer"
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        searchByName
        byName
        profileId
        DpcDetails {
          accountStatus
        }
        profile {
          phone
          name
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const employerByName = /* GraphQL */ `
  query EmployerByName(
    $searchByNameEmail: ModelEpcEmployerEmployerSearchByNameCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEpcEmployerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employerByName(
      byName: "Employer"
      searchByNameEmail: $searchByNameEmail
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        searchByName
        name
        byName
        profileId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listEPCDoctors = /* GraphQL */ `
  query ListDoctorProfiles($nextToken: String) {
    listDoctorProfiles(
      filter: { isDpcDoctor: { eq: true } }
      limit: 99999
      nextToken: $nextToken
    ) {
      items {
        id
        physicianID
        doctorName
        searchByName
        activeOnPortal
        doctorOfficePhone
        doctorWebsite
        byName
        dpcMembers(limit: 9999) {
          items {
            DpcBillingID
            DpcDetails {
              accountStatus
            }
          }
        }
        dpcUsers(limit: 9999) {
          items {
            DpcBillingID
            DpcDetails {
              accountStatus
            }
          }
        }
        doctorEmail
        startDate
        isDpcDoctor
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listMembersCustom = `
query MyQuery($filter: ModelMemberFilterInput, $limit: Int){
  listMembers(limit: $limit,filter: $filter) {
    items {
      DpcBillingID
      emailID
      group
      firstName
      lastName
      DpcDetails {
        accountStatus
      }
      id
      email
      firstName
      lastName
    }
  }
}`;

export const listEpcUsers = /* GraphQL */ `
  query ListEmployeeRegis(
    $filter: ModelEmployeeRegiFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployeeRegis(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        DpcDetails {
          accountStatus
        }
        DpcBillingID
        emailID
        epcEmployerID
        dpcDoctorID
        dpcDoctor {
          doctorName
        }
        createdAt
      }
      nextToken
    }
  }
`;

export const listEpcDependents = /* GraphQL */ `
  query MyQuery(
    $filter: ModelMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMembers(limit: $limit, filter: $filter, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        emailID
        dpcEmployeeID
        DpcDetails {
          accountStatus
        }
        DpcBillingID
        dpcDoctorID
        dpcDoctor {
          doctorName
        }
        createdAt
      }
      nextToken
    }
  }
`;

export const employeeByEmployer = /* GraphQL */ `
  query EmployeeByEmployer(
    $epcEmployerID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeRegiFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeeByEmployer(
      epcEmployerID: $epcEmployerID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        lastName
        emailID
        dpcDoctorID
        dpcDoctor {
          doctorName
        }
        profile {
          lastName
          firstName
          email
        }
        epcEmployerID
        createdAt
      }
      nextToken
      __typename
    }
  }
`;

export const getEpcEmployerPlan = /* GraphQL */ `
  query GetEpcEmployer($id: ID!) {
    getEpcEmployer(id: $id) {
      id
      planPrice
      isOnlineInvoicingActive
      billingStartMonth
      DpcBillingID
    }
  }
`;
export const listPaymentHistoryByEmployer = /* GraphQL */ `
  query ListPaymentHistoryByEmployer(
    $employerID: ID!
    $billingMonth: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEmployerPaymentHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentHistoryByEmployer(
      employerID: $employerID
      billingMonth: $billingMonth
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employerID
        billingMonth
        employeeCount
        totalAmount
        invoiceId
        invoiceStatus
        invoiceUrl
        basePrice
        invoicePdf
        createdAt
        updatedAt
        remarks
        __typename
      }
      nextToken
      __typename
    }
  }
`;
